import { CountUp } from 'countup.js';
import jQuery from 'jquery';

jQuery(function ($) {
    'use strict';

    const $counters = $('.stats__stat').find('[data-countup]');

    $counters.each(function () {
        const prefix = $(this).data('countupPrefix');
        const suffix = $(this).data('countupSuffix');
        const decimals = $(this).data('countupDecimals');

        let counter = new CountUp($(this)[0], $(this).data('countup'), {
            enableScrollSpy: true,
            decimalPlaces: decimals,
            prefix: prefix ? prefix : '',
            suffix: suffix ? suffix : '',
        });
    });
});
